import { GetDate, GetTime } from "./send";

const fileInput: HTMLInputElement = document.querySelector(".js-talk-file")!;
if (fileInput) {
  fileInput.addEventListener("change", (event: any) => {
    for (let i = 0; event.target.files.length > i; i ++) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[i]);
      reader.onload = (event: any) => {
        const src: string = event.target.result;
        ReaderOnload(src);
      }
    }
  })
}

const ReaderOnload = (src: string) => {
  const chatBox: HTMLDivElement = document.querySelector(".p-talk__chat")!;
  const sendMessage: HTMLElement = MessageTemplate(src);
  chatBox.appendChild(sendMessage);
  setTimeout(() => {
    const nowChatBox:HTMLElement = document.querySelector(".p-talk__chat")!;
    const bottom: number = nowChatBox.scrollHeight;
    chatBox.scroll({
      top: bottom,
      left: 0,
      behavior: 'smooth'
    })
  }, 100);
}


const MessageTemplate = (inputValue: string) => {
  const messageTag = document.createElement("div");
  messageTag.classList.add("c-talk__message", "c-talk__message--self", "c-talk__message--img");
  messageTag.dataset.date = GetDate();
  messageTag.dataset.time = GetTime();
  const messageImg = document.createElement("img");
  messageImg.src = inputValue;
  messageImg.alt = "送信画像";
  messageImg.classList.add("c-talk__message__img");
  messageTag.appendChild(messageImg);
  return messageTag;
}
